export default {
  forms: {
    email: 'E-mail',
    password: 'Wachtwoord',
    passwordConfirmation: 'Bevestig uw wachtwoord',
    meterNumber: 'Laatste 4 cijfers meternummer',
    houseNumber: 'Huisnummer',
    houseNumberAddition: 'Toevoeging',
    zipcode: 'Vul uw postcode in zonder spatie',
    pchn: 'PCHN',
    newPassword: 'Nieuw wachtwoord',
  },
  buttons: {
    forgotPassword: 'Wachtwoord vergeten?',
    noAccount: 'Ik heb nog geen account',
    login: 'Inloggen',
    register: 'Registreren',
    backToLogin: 'Terug naar inloggen',
    resetPassword: 'Wachtwoord herstellen',
    setPassword: 'Wachtwoord instellen',
    back: 'Terug',
    close: 'Sluiten',
  },
  validation: {
    email: {
      required: 'E-mail is vereist',
      valid: 'Voer een geldig e-mailadres in',
    },
    password: {
      required: 'Wachtwoord is vereist',
      valid:
        'Uw wachtwoord moet minimaal 8 karakters lang zijn, en minimaal 1 hoofdletter, 1 kleine letter, en 1 cijfer bevatten.',
      equal: 'Wachtwoorden zijn niet gelijk',
    },
    zipcode: {
      required: 'Postcode is vereist',
      valid: 'Voer een geldige postcode in',
    },
    houseNumber: {
      required: 'Huisnummer is vereist',
      valid: 'Voer een geldig huisnummer in',
    },
    meterNumber: {
      required: 'Meternummer is vereist',
      valid: 'Voer alleen de laatste 4 cijfers van het meternummer in',
    },
  },
  labels: {
    sinceDelivery: 'Opgeleverd',
    yield: 'Opbrengst',
    savings: 'Besparing',
    fetchingData: 'Een moment geduld alstublieft. De gegevens worden opgehaald.',
    yesterday: 'Gisteren',
    lastXDays: 'Laatste {0} dagen',
    currentYear: 'Dit jaar',
    currentMonth: 'Deze maand',
    mySolarPanels: 'Mijn Zonnepanelen',
    notLoggedIn: 'Niet ingelogd',
    loggedInAs: 'Ingelogd als',
  },
  menu: {
    overview: 'Dashboard',
    myInfo: 'Mijn gegevens',
    logout: 'Uitloggen',
    history: 'Geschiedenis',
  },
  views: {
    houseNumberAdditionInfo: {
      body: 'Alleen invullen als uw huis een adrestoevoeging heeft (bijvoorbeeld: hoog, B, BG, BIS).',
    },
    meterInfo: {
      header: 'Waar vind ik de laatste 4 cijfers van mijn meter nummer?',
      body: 'Ga in uw meterkast op zoek naar onderstaande meter van Wocozon',
    },
  },
  messages: {
    appAccessDenied: {
      title: 'De Wocozon-app is niet langer beschikbaar voor bewoners van {housingCooperativeShortName}',
      supportEnded: 'De ondersteuning via de Wocozon-app is beëindigd. U kunt de app daarom niet langer gebruiken om uw zonnepanelen te monitoren.',
      contactQuestion: 'Heeft u een vraag over uw zonnepanelen of thuisbatterij?',
      contactAnswer: 'Neem dan gerust contact op met uw woningcorporatie. Zij helpen u graag verder.',
      thanks: 'Bedankt voor het gebruik van de Wocozon-app.',
      closing: 'Met vriendelijke groet,',
    },
    appDownload: {
      title: 'Bekijk de prestaties van je zonnepanelen voortaan in de Wocozon App',
      closed: 'Mijn Zonnepanelen gaat verder als de Wocozon App. Al je opbrengst en gegevens staan er al voor je klaar, zodat je direct verder kunt waar je gebleven was.',
      downloadTitle: 'Download de Wocozon App',
      appStore: 'App Store',
      googlePlay: 'Google Play',
      instructions: 'Hulp nodig bij het installeren?',
      instructionsLink: 'Bekijk de uitleg',
      text: 'Bekijk uw opbrengst voortaan in de Wocozon-app. Download de app nu voor iOS of Android.',
      ios: 'Download voor iOS',
      android: 'Download voor Android',
    },
    activating: {
      text: 'Bezig met activeren van uw account. Een moment geduld alstublieft.',
    },
    activated: {
      text: 'Uw account is geactiveerd! U wordt binnen enkele seconden doorgestuurd naar het inlogscherm, of klik {0} om meteen door te gaan.',
      linkText: 'hier',
    },
    activationError: {
      text: 'Er is iets misgegaan tijdens het activeren. Probeer het later nogmaals.',
    },
    welcome: {
      text:
        'Welkom bij Mijn zonnepanelen! Heeft u nog geen account voor Mijn zonnepanelen? Klik dan {0} om een account aan te maken!',
      linkText: 'hier',
    },
    accountCreated: {
      text:
        'Uw account is aangemaakt. U wordt binnen enkele seconden doorgestuurd naar de inlogpagina, of klik {0} om meteen door te gaan.',
      linkText: 'hier',
    },
    resetEmailSent: {
      text:
        'De email met de link om uw wachtwoord opnieuw in te stellen is verstuurd. Niks ontvangen? U kunt het na één minuut nogmaals proberen. Nog {0} seconden resterend.',
    },
    passwordSet: {
      text:
        'Uw wachtwoord is aangepast. U wordt binnen enkele seconden doorgestuurd naar het inlogscherm, of klik {0} om meteen door te gaan.',
      linkText: 'hier',
    },
    zeroYieldMessage: {
      text: 'We hebben nog niet alle gegevens binnen om de opwekking van gisteren weer te geven. Dit kan wel eens voorkomen. Probeert u het morgen nog eens.',
    },
    disturbanceMessage: {
      text: 'Momenteel is er een storing, hierdoor kan een aantal bewoners geen gegevens zien. Er wordt hard aan gewerkt om de storing op te lossen. U hoeft zich geen zorgen te maken over de opwekking, die gaat gewoon door. Excuses voor het eventuele ongemak. Let op: zodra u wel opwekking ziet staan in uw dashboard, heeft u geen last van de storing. U mag deze melding dan negeren.',
    },
  },
};
